export default __webpack_public_path__ + "static/media/APN News.37b71e19.png";